export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}

/**
 * Renders the selected crop region to a square canvas of `output` px and returns
 * a JPEG blob — the cropped, zoomed face ready to upload (LinkedIn-style).
 */
export async function getCroppedBlob(
  imageSrc: string,
  crop: PixelCrop,
  output = 512,
): Promise<Blob> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = output;
  canvas.height = output;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('CANVAS_UNAVAILABLE');

  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    image,
    crop.x, crop.y, crop.width, crop.height,
    0, 0, output, output,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('BLOB_FAILED'))),
      'image/jpeg',
      0.9,
    );
  });
}

/** Read a File into a data URL for the cropper preview. */
export function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
